<app-page-heading [key]="'regions.list.page-title'"></app-page-heading>


<section class="container-fluid summary-panel">
    <app-data-table [columns]="columns"
                    [sortColumn]="sortColumn"
                    [direction]="SortDirection.ASC"
                    [loadPage]="loadPage"
                    [allowItemSelection]="true"
                    [(filters)]="filters"
                    [filtersComponent]="dataFilters"
                    [noResultLabelKey]="'regions.list.no-result'"
                    (onLoad)="pageLoaded()"
                    (onItemSelection)="goToEditRegion($event.id)">
        <app-data-filters #dataFilters [opened]="true" [fullWidth]="true">
            <app-data-filter-group [useAvailableWidth]="true">
                <app-data-filter-input [labelKey]="'regions.list.filters.name.label'" [(model)]="filters.name"
                                       [placeholderKey]="'regions.list.filters.name.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'regions.list.filters.country.label'" [(model)]="filters.country"
                                       [placeholderKey]="'regions.list.filters.country.placeholder'"></app-data-filter-input>
            </app-data-filter-group>
        </app-data-filters>
    </app-data-table>
</section>

<spacer size="98"></spacer>

<ng-template #nameColumn let-name="name">
    <span class="regionName">{{ name }}</span>
</ng-template>

<ng-template #languageColumn let-language="preferredLanguage">
    <span class="regionName" [i18n]="'languages.' + Languages.fromLocale(language)['labelKey']"></span>
</ng-template>

<ng-template #timezoneColumn let-timezone="preferredTimezone">
    <span class="regionName">{{ timezone }}</span>
</ng-template>

<ng-template #tmsSynchronizationColumn let-tmsSyncTimeSlots="tmsSyncWindows">
    <div class="countryList">
        <span class="country-name" *ngFor="let tmsSyncTimeSlot of tmsSyncTimeSlots"
              [i18n]="'regions.form.tms-sync-time.' + formatTmsSyncTimeslot(tmsSyncTimeSlot)"></span>
    </div>
</ng-template>

<ng-template #countriesColumn let-countries="countries">
    <div class="countryList">
        <span class="country-name" *ngFor="let country of countries">
            {{country.displayLabel}}
        </span>
    </div>
</ng-template>

<div class="footer">
    <button class="btn btn-primary btn-lg pull-right" (click)="goToCreateRegion()">
        <span class="fa fa-plus"></span> &nbsp; <span [i18n]="[{target: 'innerHTML', key: 'regions.list.buttons.create'}]"></span>
    </button>
</div>

<!--TODO@dev button doesn't work-->
<!--<app-floating-footer></app-floating-footer>-->
